import { Component } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-quality-management-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './quality-management-file-manager.component.html',
  styleUrl: './quality-management-file-manager.component.scss'
})
export class QualityManagementFileManagerComponent {
  initialPath: string = 'qualityManagement';
}
